function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import $ from 'dom7';
import Utils from '../../utils/utils';
import Framework7Class from '../../utils/class';
import swipePanel from './swipe-panel';
import resizablePanel from './resizable-panel';

var Panel = /*#__PURE__*/function (_Framework7Class) {
  _inherits(Panel, _Framework7Class);

  var _super = _createSuper(Panel);

  function Panel(app) {
    var _this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Panel);

    var extendedParams = Utils.extend({
      on: {}
    }, app.params.panel, params);
    _this = _super.call(this, extendedParams, [app]);

    var panel = _assertThisInitialized(_this);

    panel.params = extendedParams;
    panel.$containerEl = panel.params.containerEl ? $(panel.params.containerEl).eq(0) : app.root;
    panel.containerEl = panel.$containerEl[0];
    var $el;

    if (panel.params.el) {
      $el = $(panel.params.el).eq(0);
    } else if (panel.params.content) {
      $el = $(panel.params.content).filter(function (elIndex, node) {
        return node.nodeType === 1;
      }).eq(0);
    }

    if ($el.length === 0) return _possibleConstructorReturn(_this, panel);
    if ($el[0].f7Panel) return _possibleConstructorReturn(_this, $el[0].f7Panel);
    $el[0].f7Panel = panel;
    var _panel$params = panel.params,
        side = _panel$params.side,
        effect = _panel$params.effect,
        resizable = _panel$params.resizable;
    if (typeof side === 'undefined') side = $el.hasClass('panel-left') ? 'left' : 'right';
    if (typeof effect === 'undefined') effect = $el.hasClass('panel-cover') ? 'cover' : 'reveal';
    if (typeof resizable === 'undefined') resizable = $el.hasClass('panel-resizable');
    var $backdropEl;

    if (panel.params.backdrop && panel.params.backdropEl) {
      $backdropEl = $(panel.params.backdropEl);
    } else if (panel.params.backdrop) {
      $backdropEl = panel.$containerEl.children('.panel-backdrop');

      if ($backdropEl.length === 0) {
        $backdropEl = $('<div class="panel-backdrop"></div>');
        panel.$containerEl.prepend($backdropEl);
      }
    }

    Utils.extend(panel, {
      app: app,
      side: side,
      effect: effect,
      resizable: resizable,
      $el: $el,
      el: $el[0],
      opened: false,
      $backdropEl: $backdropEl,
      backdropEl: $backdropEl && $backdropEl[0]
    }); // Install Modules

    panel.useModules(); // Init

    panel.init();
    return _possibleConstructorReturn(_this, panel);
  }

  _createClass(Panel, [{
    key: "getViewEl",
    value: function getViewEl() {
      var panel = this;
      var viewEl;

      if (panel.$containerEl.children('.views').length > 0) {
        viewEl = panel.$containerEl.children('.views')[0];
      } else {
        viewEl = panel.$containerEl.children('.view')[0];
      }

      return viewEl;
    }
  }, {
    key: "enableVisibleBreakpoint",
    value: function enableVisibleBreakpoint() {
      var panel = this;
      panel.visibleBreakpointDisabled = false;
      panel.setVisibleBreakpoint();
      return panel;
    }
  }, {
    key: "disableVisibleBreakpoint",
    value: function disableVisibleBreakpoint() {
      var panel = this;
      panel.visibleBreakpointDisabled = true;
      panel.setVisibleBreakpoint();
      return panel;
    }
  }, {
    key: "toggleVisibleBreakpoint",
    value: function toggleVisibleBreakpoint() {
      var panel = this;
      panel.visibleBreakpointDisabled = !panel.visibleBreakpointDisabled;
      panel.setVisibleBreakpoint();
      return panel;
    }
  }, {
    key: "setVisibleBreakpoint",
    value: function setVisibleBreakpoint() {
      var emitEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var panel = this;
      var app = panel.app;

      if (!panel.visibleBreakpointResizeHandler) {
        panel.visibleBreakpointResizeHandler = function visibleBreakpointResizeHandler() {
          panel.setVisibleBreakpoint();
        };

        app.on('resize', panel.visibleBreakpointResizeHandler);
      }

      var side = panel.side,
          $el = panel.$el,
          params = panel.params,
          visibleBreakpointDisabled = panel.visibleBreakpointDisabled;
      var breakpoint = params.visibleBreakpoint;
      var $viewEl = $(panel.getViewEl());
      var wasVisible = $el.hasClass('panel-in-breakpoint');

      if (app.width >= breakpoint && typeof breakpoint !== 'undefined' && breakpoint !== null && !visibleBreakpointDisabled) {
        if (!wasVisible) {
          $('html').removeClass("with-panel-".concat(side, "-reveal with-panel-").concat(side, "-cover with-panel"));
          $el.addClass('panel-in-breakpoint').removeClass('panel-in panel-in-collapsed');
          panel.onOpen(false);
          panel.onOpened();
          $viewEl.css(_defineProperty({}, "margin-".concat(side), "".concat($el.width(), "px")));
          app.allowPanelOpen = true;

          if (emitEvents) {
            panel.emit('local::breakpoint panelBreakpoint', panel);
            panel.$el.trigger('panel:breakpoint');
          }
        } else {
          $viewEl.css(_defineProperty({}, "margin-".concat(side), "".concat($el.width(), "px")));
        }
      } else if (wasVisible) {
        $el.removeClass('panel-in-breakpoint panel-in');
        panel.onClose();
        panel.onClosed();
        $viewEl.css(_defineProperty({}, "margin-".concat(side), ''));

        if (emitEvents) {
          panel.emit('local::breakpoint panelBreakpoint', panel);
          panel.$el.trigger('panel:breakpoint');
        }
      }
    }
  }, {
    key: "enableCollapsedBreakpoint",
    value: function enableCollapsedBreakpoint() {
      var panel = this;
      panel.collapsedBreakpointDisabled = false;
      panel.setCollapsedBreakpoint();
      return panel;
    }
  }, {
    key: "disableCollapsedBreakpoint",
    value: function disableCollapsedBreakpoint() {
      var panel = this;
      panel.collapsedBreakpointDisabled = true;
      panel.setCollapsedBreakpoint();
      return panel;
    }
  }, {
    key: "toggleCollapsedBreakpoint",
    value: function toggleCollapsedBreakpoint() {
      var panel = this;
      panel.collapsedBreakpointDisabled = !panel.collapsedBreakpointDisabled;
      panel.setCollapsedBreakpoint();
      return panel;
    }
  }, {
    key: "setCollapsedBreakpoint",
    value: function setCollapsedBreakpoint(emitEvents) {
      var panel = this;
      var app = panel.app;

      if (!panel.collapsedBreakpointResizeHandler) {
        panel.collapsedBreakpointResizeHandler = function collapsedBreakpointResizeHandler() {
          panel.setCollapsedBreakpoint();
        };

        app.on('resize', panel.collapsedBreakpointResizeHandler);
      }

      var side = panel.side,
          $el = panel.$el,
          params = panel.params,
          collapsedBreakpointDisabled = panel.collapsedBreakpointDisabled;
      if ($el.hasClass('panel-in-breakpoint')) return;
      var breakpoint = params.collapsedBreakpoint;
      var wasVisible = $el.hasClass('panel-in-collapsed');

      if (app.width >= breakpoint && typeof breakpoint !== 'undefined' && breakpoint !== null && !collapsedBreakpointDisabled) {
        if (!wasVisible) {
          $('html').removeClass("with-panel-".concat(side, "-reveal with-panel-").concat(side, "-cover with-panel"));
          $el.addClass('panel-in-collapsed').removeClass('panel-in');
          panel.collapsed = true;
          app.allowPanelOpen = true;

          if (emitEvents) {
            panel.emit('local::collapsedBreakpoint panelCollapsedBreakpoint', panel);
            panel.$el.trigger('panel:collapsedbreakpoint');
          }
        }
      } else if (wasVisible) {
        $el.removeClass('panel-in-collapsed panel-in');
        panel.collapsed = false;

        if (emitEvents) {
          panel.emit('local::collapsedBreakpoint panelCollapsedBreakpoint', panel);
          panel.$el.trigger('panel:collapsedbreakpoint');
        }
      }
    }
  }, {
    key: "enableResizable",
    value: function enableResizable() {
      var panel = this;

      if (panel.resizableInitialized) {
        panel.resizable = true;
        panel.$el.addClass('panel-resizable');
      } else {
        resizablePanel(panel);
      }

      return panel;
    }
  }, {
    key: "disableResizable",
    value: function disableResizable() {
      var panel = this;
      panel.resizable = false;
      panel.$el.removeClass('panel-resizable');
      return panel;
    }
  }, {
    key: "enableSwipe",
    value: function enableSwipe() {
      var panel = this;

      if (panel.swipeInitialized) {
        panel.swipeable = true;
      } else {
        swipePanel(panel);
      }

      return panel;
    }
  }, {
    key: "disableSwipe",
    value: function disableSwipe() {
      var panel = this;
      panel.swipeable = false;
      return panel;
    }
  }, {
    key: "onOpen",
    value: function onOpen() {
      var modifyHtmlClasses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var panel = this;
      var app = panel.app;
      panel.opened = true;
      app.panel.allowOpen = false;
      panel.$el.trigger('panel:beforeopen');
      panel.emit('local::beforeOpen panelBeforeOpen', panel);

      if (modifyHtmlClasses) {
        $('html').addClass("with-panel with-panel-".concat(panel.side, "-").concat(panel.effect));
      }

      panel.$el.trigger('panel:open');
      panel.emit('local::open panelOpen', panel);
    }
  }, {
    key: "onOpened",
    value: function onOpened() {
      var panel = this;
      var app = panel.app;
      app.panel.allowOpen = true;
      panel.$el.trigger('panel:opened');
      panel.emit('local::opened panelOpened', panel);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var panel = this;
      var app = panel.app;
      panel.opened = false;
      app.panel.allowOpen = false;
      panel.$el.trigger('panel:beforeclose');
      panel.emit('local::beforeClose panelBeforeClose', panel);
      $('html').addClass('with-panel-closing');
      $('html').removeClass("with-panel with-panel-".concat(panel.side, "-").concat(panel.effect));
      panel.$el.trigger('panel:close');
      panel.emit('local::close panelClose', panel);
    }
  }, {
    key: "onClosed",
    value: function onClosed() {
      var panel = this;
      var app = panel.app;
      app.panel.allowOpen = true;
      $('html').removeClass('with-panel-closing');
      panel.$el.removeClass('panel-out');

      if (panel.$backdropEl) {
        var otherPanel = app.panel.get('.panel-in');
        var shouldHideBackdrop = !otherPanel || otherPanel && !otherPanel.$backdropEl;

        if (shouldHideBackdrop) {
          panel.$backdropEl.removeClass('panel-backdrop-in');
        }
      }

      panel.$el.trigger('panel:closed');
      panel.emit('local::closed panelClosed', panel);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var panel = this;
      var breakpoint = panel.params.visibleBreakpoint;
      var app = panel.app;

      if (app.width >= breakpoint && typeof breakpoint !== 'undefined' && breakpoint !== null) {
        return panel.toggleVisibleBreakpoint();
      }

      if (panel.opened) panel.close(animate);else panel.open(animate);
      return panel;
    }
  }, {
    key: "insertToRoot",
    value: function insertToRoot() {
      var panel = this;
      var $el = panel.$el,
          $backdropEl = panel.$backdropEl,
          $containerEl = panel.$containerEl;
      var $panelParentEl = $el.parent();
      var wasInDom = $el.parents(document).length > 0;

      if (!$panelParentEl.is($containerEl) || $el.prevAll('.views, .view').length) {
        var $insertBeforeEl = $containerEl.children('.panel, .views, .view').eq(0);
        var $insertAfterEl = $containerEl.children('.panel-backdrop').eq(0);

        if ($insertBeforeEl.length) {
          $el.insertBefore($insertBeforeEl);
        } else if ($insertAfterEl) {
          $el.insertBefore($insertAfterEl);
        } else {
          $containerEl.prepend($el);
        }

        if ($backdropEl && $backdropEl.length && (!$backdropEl.parent().is($containerEl) && $backdropEl.nextAll('.panel').length === 0 || $backdropEl.parent().is($containerEl) && $backdropEl.nextAll('.panel').length === 0)) {
          $backdropEl.insertBefore($el);
        }

        panel.once('panelClosed', function () {
          if (wasInDom) {
            $panelParentEl.append($el);
          } else {
            $el.remove();
          }
        });
      }
    }
  }, {
    key: "open",
    value: function open() {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var panel = this;
      var app = panel.app;
      if (!app.panel.allowOpen) return false;
      var effect = panel.effect,
          $el = panel.$el,
          $backdropEl = panel.$backdropEl,
          opened = panel.opened;

      if (!$el || $el.hasClass('panel-in')) {
        return panel;
      }

      panel.insertToRoot(); // Ignore if opened

      if (opened || $el.hasClass('panel-in-breakpoint') || $el.hasClass('panel-in')) return false; // Close if some panel is opened

      var otherOpenedPanel = app.panel.get('.panel-in');

      if (otherOpenedPanel && otherOpenedPanel !== panel) {
        otherOpenedPanel.close(animate);
      }

      $el[animate ? 'removeClass' : 'addClass']('not-animated');
      $el.addClass('panel-in');

      if ($backdropEl) {
        $backdropEl.addClass('panel-backdrop-in');
        $backdropEl[animate ? 'removeClass' : 'addClass']('not-animated');
      }

      if (panel.effect === 'cover') {
        /* eslint no-underscore-dangle: ["error", { "allow": ["_clientLeft"] }] */
        panel._clientLeft = $el[0].clientLeft;
      } // Transitionend


      var transitionEndTarget = effect === 'reveal' ? $el.nextAll('.view, .views').eq(0) : $el;

      function panelTransitionEnd() {
        transitionEndTarget.transitionEnd(function (e) {
          if ($(e.target).is(transitionEndTarget)) {
            if ($el.hasClass('panel-out')) {
              panel.onClosed();
            } else {
              panel.onOpened();
            }
          } else panelTransitionEnd();
        });
      }

      if (animate) {
        if ($backdropEl) {
          $backdropEl.removeClass('not-animated');
        }

        panelTransitionEnd();
        $el.removeClass('panel-out not-animated').addClass('panel-in');
        panel.onOpen();
      } else {
        if ($backdropEl) {
          $backdropEl.addClass('not-animated');
        }

        $el.removeClass('panel-out').addClass('panel-in not-animated');
        panel.onOpen();
        panel.onOpened();
      }

      return true;
    }
  }, {
    key: "close",
    value: function close() {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var panel = this;
      var effect = panel.effect,
          $el = panel.$el,
          $backdropEl = panel.$backdropEl,
          opened = panel.opened;
      if (!opened || $el.hasClass('panel-in-breakpoint') || !$el.hasClass('panel-in')) return panel;
      $el[animate ? 'removeClass' : 'addClass']('not-animated');

      if ($backdropEl) {
        $backdropEl[animate ? 'removeClass' : 'addClass']('not-animated');
      }

      var transitionEndTarget = effect === 'reveal' ? $el.nextAll('.view, .views').eq(0) : $el;

      function transitionEnd() {
        if ($el.hasClass('panel-out')) {
          panel.onClosed();
        } else if ($el.hasClass('panel-in')) {
          panel.onOpened();
        }

        $('html').removeClass('with-panel-closing');
      }

      if (animate) {
        transitionEndTarget.transitionEnd(function () {
          transitionEnd();
        });
        $el.removeClass('panel-in').addClass('panel-out'); // Emit close

        panel.onClose();
      } else {
        $el.addClass('not-animated').removeClass('panel-in').addClass('panel-out'); // Emit close

        panel.onClose();
        panel.onClosed();
      }

      return panel;
    }
  }, {
    key: "init",
    value: function init() {
      var panel = this; // const app = panel.app;

      if (typeof panel.params.visibleBreakpoint !== 'undefined') {
        panel.setVisibleBreakpoint();
      }

      if (typeof panel.params.collapsedBreakpoint !== 'undefined') {
        panel.setCollapsedBreakpoint();
      }

      if (panel.params.swipe) {
        panel.enableSwipe();
      }

      if (panel.resizable) {
        panel.enableResizable();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var panel = this;
      var app = panel.app;

      if (!panel.$el) {
        // Panel already destroyed
        return;
      }

      panel.emit('local::beforeDestroy panelBeforeDestroy', panel);
      panel.$el.trigger('panel:beforedestroy');

      if (panel.visibleBreakpointResizeHandler) {
        app.off('resize', panel.visibleBreakpointResizeHandler);
      }

      if (panel.collapsedBreakpointResizeHandler) {
        app.off('resize', panel.collapsedBreakpointResizeHandler);
      }

      if (panel.$el.hasClass('panel-in-breakpoint') || panel.$el.hasClass('panel-in-collapsed')) {
        var $viewEl = $(panel.getViewEl());
        panel.$el.removeClass('panel-in-breakpoint panel-in-collapsed panel-in');
        $viewEl.css(_defineProperty({}, "margin-".concat(panel.side), ''));
        panel.emit('local::breakpoint panelBreakpoint', panel);
        panel.$el.trigger('panel:breakpoint');
      }

      panel.$el.trigger('panel:destroy');
      panel.emit('local::destroy panelDestroy', panel);

      if (panel.el) {
        panel.el.f7Panel = null;
        delete panel.el.f7Panel;
      }

      Utils.deleteProps(panel);
      panel = null;
    }
  }]);

  return Panel;
}(Framework7Class);

export default Panel;